// export const apiUrl = "https://apierp.mynet.co.id";
// export const apiUrl = "https://apimynet.hulwa.co.id";
// export const apiv3Url = "https://api-mynet-v3.local";
// export const apiv3Url = "https://apimynet2.hulwa.co.id";
// Baked in at build time (CI passes REACT_APP_API_V3_URL as a Docker
// build-arg, branch-aware — see Dockerfile + .gitlab-ci.yml). Falls back to
// prod so a plain local `yarn build`/`yarn start` behaves as it always has.
export const apiv3Url = process.env.REACT_APP_API_V3_URL || "https://apierp2.mynet.co.id";
// export const urlClient = "http://127.0.0.1:8000";
// export const urlClient = "https://user-mynet-v3.local";
// export const urlClient = "https://user.hulwa.co.id";
// export const urlClient = "https://userdev-dt.mynet.co.id";
export const urlClient = "https://user.mynet.co.id";
export const urlCoorporate = "https://erp-corp.mynet.co.id";

// export const apiv3Url = "http://api-erp-mynet.test";
// export const urlClient = "http://user-erp-mynet.test";
// export const urlCoorporate = "https://erp-sales-corporate.test";

export const paymentVaTypeStatic = true;

export const admin_price = 2500;

export function removeCSSClass(ele, cls) {
  const reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
  ele.className = ele.className.replace(reg, " ");
}

export function addCSSClass(ele, cls) {
  ele.classList.add(cls);
}

export const toAbsoluteUrl = (pathname) => process.env.PUBLIC_URL + pathname;

export const salesRetailFilter = (x, clusterOutsideMynetOffice = []) => {
  // ponytail: safe optional chaining for roleName
  const roleName = x?.role_info?.role_name || x?.role?.name || "";

  if (clusterOutsideMynetOffice.length > 0) {
    return clusterOutsideMynetOffice[0].salesRole.includes(roleName);
  }
  return (
    roleName === "Sales Retail"
    // roleName === "Sales Retail" ||
    // roleName === "Admin Teknisi Retail" ||
    // roleName === "Admin Teknisi Retail Khusus"
  );
};
export const salesRecurringFilter = (x, clusterOutsideMynetOffice = []) => {
  const roleName = x?.role_info?.role_name || x?.role?.name || "";
  if (clusterOutsideMynetOffice.length > 0) {
    return clusterOutsideMynetOffice[0].recurringRole.includes(roleName);
  }
  return roleName === "Sales Recurring" || roleName === "Super Admin";
  // return (roleName === "Sales Recurring");
};
export const salesJatinangorFilter = (x) => {
  const roleName = x?.role_info?.role_name || x?.role?.name || "";
  return roleName === "Sales Jatinangor";
};
export const salesCorporateFilter = (x) => {
  const roleName = x?.role_info?.role_name || x?.role?.name || "";
  return roleName === "Sales Corporate";
};
export const teknisiRetailFilter = (x, clusterOutsideMynetOffice = []) => {
  const roleName = x?.role_info?.role_name || x?.role?.name || "";
  if (clusterOutsideMynetOffice.length > 0) {
    return clusterOutsideMynetOffice[0].teknisiRole.includes(roleName);
  }
  return (
    roleName === "Teknisi Retail" ||
    roleName === "Teknisi Corporate" ||
    roleName === "Admin Teknisi Retail" ||
    roleName === "Admin Teknisi Retail Khusus" ||
    roleName === "IKR" ||
    roleName === "Lead Backbone" ||
    roleName === "Teknisi Backbone"
  );
};
export const teknisiDismantleFilter = (x, clusterOutsideMynetOffice = []) => {
  const roleName = x?.role_info?.role_name || x?.role?.name || "";
  if (clusterOutsideMynetOffice.length > 0) {
    return clusterOutsideMynetOffice[0].dismantleRole.includes(roleName);
  }
  return (
    roleName === "Teknisi Retail" ||
    roleName === "Teknisi Corporate" ||
    roleName === "Admin Teknisi Retail" ||
    roleName === "Admin Teknisi Retail Khusus" ||
    roleName === "IKR" ||
    roleName === "Lead Backbone" ||
    roleName === "Teknisi Backbone"
  );
};
export const superAdminFilter = (x) => {
  const roleName = x?.role_info?.role_name || x?.role?.name || "";
  return (
    roleName === "Super Admin" ||
    roleName === "Direktur" ||
    roleName === "Admin Teknisi Retail Khusus"
  );
};
export const financeHrdFilter = (x) => {
  const roleName = x?.role_info?.role_name || x?.role?.name || "";
  return roleName === "HRD" || roleName === "Finance";
};
export const teknisiCorporateFilter = (x) => {
  const roleName = x?.role_info?.role_name || x?.role?.name || "";
  return roleName === "Teknisi Retail" || roleName === "Teknisi Corporate";
};
export const teknisiNOCFilter = (x, clusterOutsideMynetOffice = []) => {
  const roleName = x?.role_info?.role_name || x?.role?.name || "";
  return roleName === "NOC";
};
export const teknisiJatinangorFilter = (x) => {
  const roleName = x?.role_info?.role_name || x?.role?.name || "";
  return roleName === "Teknisi Jatinangor";
};

export const getClusterOutsideMynetOfficeFilter = (accountRole) => {
  const clusterRoles = [
    {
      cluster: ["Bojonegoro"],
      role: ["Sales Bojonegoro", "Teknisi Bojonegoro", "Admin Bojonegoro"],
      salesRole: ["Sales Bojonegoro", "Admin Bojonegoro"],
      teknisiRole: ["Teknisi Bojonegoro", "Admin Bojonegoro"],
      recurringRole: ["Admin Bojonegoro"],
      dismantleRole: ["Admin Bojonegoro"],
      nocRole: ["Admin Bojonegoro"],
      wh_address: ["Bojonegoro"],
    },
    {
      cluster: [
        "MARGA MULYA",
        "MARGA RAHAYU",
        "MARGA MULYA",
        "MAJAPAHIT",
        "TANAH PERIUK",
        "NIKAN JAYA",
        "SIMPANG PERIUK",
        "MARGA RAHAYU",
        "MERASI",
        "KALI KESIK",
      ],
      role: [
        "Sales Lubuklinggau",
        "Teknisi Lubuklinggau",
        "Admin Lubuklinggau",
      ],
      salesRole: ["Sales Lubuklinggau", "Admin Lubuklinggau"],
      teknisiRole: ["Teknisi Lubuklinggau", "Admin Lubuklinggau"],
      recurringRole: ["Admin Lubuklinggau"],
      dismantleRole: ["Admin Lubuklinggau"],
      nocRole: ["Admin Lubuklinggau"],
      wh_address: ["Lubuk Linggau"],
    },
  ];
  const itemFilter = clusterRoles.filter((item) => {
    return item.role.includes(accountRole);
  });

  return itemFilter;
};
